import { render, staticRenderFns } from "./WelcomeTofasTrust.vue?vue&type=template&id=31a55548"
import script from "./WelcomeTofasTrust.vue?vue&type=script&lang=js"
export * from "./WelcomeTofasTrust.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports